import { useSessionContext } from "features/auth";
import { ReactElement } from "react";
import { Navigate } from "react-router-dom";

import { ROUTES } from "./constants";

export const UnauthenticatedRoute = ({
  children,
}: {
  children: ReactElement;
}) => {
  const { isLoggedIn } = useSessionContext();

  const origin = ROUTES.DASHBOARD_FACILITY;
  if (isLoggedIn) {
    return <Navigate to={origin} replace />;
  }

  return children;
};
